import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "./HomePage";
import CompletedPage from "./CompletedPage";
import Dummy from "./Dummy";

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Dummy />} />
        <Route path="/scanlinks/:uuid" element={<HomePage />} />
        <Route path="/completed" element={<CompletedPage />} />
      </Routes>
    </Router>
  );
}

export default App;
